// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zbjl","question":"styles_question__QRAlQ","inputVisibleButton":"styles_inputVisibleButton__2WPos","note":"styles_note__1LXbR"};